import { ListItem } from '../../shared/list-confirmation/model/list-item';

export class BenefactorDataModel {
	id?: number;
	name?: string;
	cpfCnpj?: string;
	agency?: string;
	accountNumber?: string;
	bankCode?: string;
	bankDesc?: string;
	modality?: string;
	modalityAll?: string;
	ownership?: number;

	success?: boolean;
	message?: string;
	resumeList?: Array<ListItem>;

	constructor() { }
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/models/benefactorData.ts